module.exports = __webpack_public_path__ + "img/IMG_3450_L_BlackMatted.3454cca3.jpg";